
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coaches/[id]/matches",
      function () {
        return require("private-next-pages/coaches/[id]/matches.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coaches/[id]/matches"])
      });
    }
  